module.exports = "/assets/data/8740a539dc376f5bf2d220dc825b5107-LS9.data.json";